import $ from 'jquery'
const $doc = $(document)
